//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.type

import com.apollographql.apollo.api.Fragment
import com.apollographql.apollo.api.UnionType

public class LexicalItemDetail {
  public interface Data : Fragment.Data

  public companion object {
    public val type: UnionType =
        UnionType("LexicalItemDetail", Forms.type, WordTranslations.type, Synonyms.type, Explanation.type, Example.type)
  }
}
